module.exports = __webpack_public_path__ + "img/block_01_img.0c81e900.png";